import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import store from '../../store'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'

export interface ITag {
  id: number
  code: string
  value: string
  isDeleted: boolean
  slug: string
}

export interface IEditTag extends ITag {
  isEdited?: boolean
  softDeleted?: boolean
  isAdded?: boolean
}

const searchTags = async (filter: string): Promise<ITag[]> => {
  var state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) return [] as ITag[]

  const response = await createRequest(
    `/api/Tags/search/?filter=${filter}&config=${state.present.article.serverConfig}`,
    'GET',
    undefined,
    token,
    true,
    true,
  ).then(response => response.json())

  return response
}

const retrieveArticlesTags = (fullSearch: boolean = false): Promise<ITag[]> => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  const rowKeysSelected = state.present.article.rowKeysSelected

  if (!state.present.article.serverConfig || (rowKeysSelected.length === 0 && !fullSearch) || !token) {
    return new Promise(resolve => resolve([] as ITag[]))
  }

  const body = {
    articleIds: rowKeysSelected,
  }

  return createRequest(
    `/api/Tags/retrieveArticlesTags?config=${state.present.article.serverConfig}`,
    'POST',
    body,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to retrieve articles tags')
    })
}

//**************** */
//le modifiche ai tag e alle associazioni con gli articoli sono state accorpate all'updateArticles
//**************** */

export { searchTags, retrieveArticlesTags }
